/**
 * Request bodies for `/api/users` and the admin routes (backend.md §4.2).
 */
import { z } from 'zod';
import { paceTierSchema } from '../pace.js';
import { displayNameSchema, localeSchema, passwordSchema } from './common.js';
export const updateProfileBodySchema = z
    .object({
    displayName: displayNameSchema,
    locale: localeSchema,
    defaultPaceTier: paceTierSchema,
})
    .partial()
    .refine((v) => Object.values(v).some((f) => f !== undefined), 'no_fields_to_update');
export const changePasswordBodySchema = z.object({
    currentPassword: z.string().min(1).max(128),
    newPassword: passwordSchema,
});
export const avatarPresetBodySchema = z.object({
    presetId: z
        .string()
        .trim()
        .min(1)
        .max(32)
        .regex(/^[a-z0-9-]+$/),
});
// ─────────────────────────────────────────────────────────────── admin bodies
export const USER_STATUSES = ['pending', 'active', 'banned', 'deleted'];
export const userStatusSchema = z.enum(USER_STATUSES);
export const USER_ROLES = ['user', 'admin'];
export const adminUserQuerySchema = z.object({
    q: z.string().trim().max(254).optional(),
    status: userStatusSchema.optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
export const banBodySchema = z.object({
    reason: z.string().trim().min(3).max(500),
    /** ISO 8601. Absent means indefinite. */
    until: z.string().datetime({ offset: true }).optional(),
});
export const REPORT_REASONS = ['abuse', 'cheating', 'collusion', 'spam', 'other'];
export const reportReasonSchema = z.enum(REPORT_REASONS);
export const REPORT_STATUSES = ['open', 'reviewed', 'dismissed'];
export const reportStatusSchema = z.enum(REPORT_STATUSES);
export const adminReportQuerySchema = z.object({
    status: reportStatusSchema.optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
/** `open` is not a review outcome, so it is not a legal transition target. */
export const updateReportBodySchema = z.object({
    status: z.enum(['reviewed', 'dismissed']),
});
export const uuidParamSchema = z.object({ id: z.string().uuid() });
//# sourceMappingURL=profile.js.map